import type { MutationOptions } from '@tanstack/react-query';
import { useMutation } from '@tanstack/react-query';

import { getTokensByAuthorizationCodeApi } from 'api/auth';
import type { GetUserAuthTokensResponseDTO } from 'declarations/dto/auth';
import { RequestQueryKeysE } from 'declarations/enums/react-query';
import type { ApiErrorI } from 'declarations/interfaces/errors';

type useFetchUserAuthTokensParams = {
  onSuccess: MutationOptions<GetUserAuthTokensResponseDTO, ApiErrorI, string>['onSuccess'];
};

export const useFetchUserAuthTokens = ({
  onSuccess,
}: useFetchUserAuthTokensParams): ReturnType<
  typeof useMutation<GetUserAuthTokensResponseDTO, ApiErrorI, string>
> =>
  useMutation<GetUserAuthTokensResponseDTO, ApiErrorI, string>(
    [RequestQueryKeysE.FetchUserAuthTokens],
    getTokensByAuthorizationCodeApi,
    { onSuccess }
  );
